import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';

class FindClass {
	constructor () {
		this.form = SelectorEngine.findOne('form.js-lta-class-results');
		if(!this.form) { return; }
		this.initEvents();
	}

	initEvents() {

		EventHandler.on(this.form, 'btnchange', () => {
			setTimeout( () => this.form.submit(), 10);
		});
	}
}

const globalFindClass = new FindClass();

export default globalFindClass;

